export type ApproximateLocation = {
  latitude: number;
  longitude: number;
};

const MARKET_CENTERS: Record<string, ApproximateLocation> = {
  SE: { latitude: 59.32938, longitude: 18.06871 },
  DK: { latitude: 55.67594, longitude: 12.56553 },
  NO: { latitude: 59.91273, longitude: 10.74609 },
  FI: { latitude: 60.16952, longitude: 24.93545 },
};

export function getMarketCenter(countryCode: string | null | undefined) {
  return countryCode ? (MARKET_CENTERS[countryCode.toUpperCase()] ?? null) : null;
}

export function parseApproximateLocation(value: unknown): ApproximateLocation | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const { latitude, longitude } = value as Record<string, unknown>;

  return validateCoordinate(latitude, longitude);
}

export function parseCloudflareApproximateLocation(value: unknown): ApproximateLocation | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const { latitude, longitude } = value as Record<string, unknown>;
  const coordinate = validateCoordinate(toNumber(latitude), toNumber(longitude));

  if (!coordinate) {
    return null;
  }

  return {
    latitude: roundToTwoDecimals(coordinate.latitude),
    longitude: roundToTwoDecimals(coordinate.longitude),
  };
}

function validateCoordinate(latitude: unknown, longitude: unknown): ApproximateLocation | null {
  if (
    typeof latitude !== 'number' ||
    typeof longitude !== 'number' ||
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    latitude < -90 ||
    latitude > 90 ||
    longitude < -180 ||
    longitude > 180
  ) {
    return null;
  }

  return { latitude, longitude };
}

function toNumber(value: unknown) {
  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    return Number(value);
  }

  return Number.NaN;
}

function roundToTwoDecimals(value: number) {
  return Math.round(value * 100) / 100;
}
